import * as React from 'react'

import { Outlet } from 'react-router-dom'

import DashboardSidebar from '@/layouts/dashboard/DashboardSidebar'
import { SiteHeader } from '@/layouts/dashboard/SiteHeader'

import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'

import OfflineModal from '../../components/OfflineModal'

export function DashboardLayout() {
  return (
    <SidebarProvider
      style={
        {
          '--sidebar-width': '18rem',
          '--sidebar-width-mobile': '18rem',
          '--header-height': 'calc(var(--spacing) * 14)',
        } as React.CSSProperties
      }
    >
      <DashboardSidebar />
      <SidebarInset className='flex flex-col'>
        <SiteHeader />
        <main className='flex flex-1 flex-col overflow-auto bg-gray-50/80'>
          <div className='flex flex-1 flex-col'>
            <div className='@container/main flex flex-1 flex-col gap-2'>
              <Outlet />
            </div>
          </div>
        </main>
        <OfflineModal />
      </SidebarInset>
    </SidebarProvider>
  )
}
